module.exports = __webpack_public_path__ + "9b06fa4f8b0a307f575e4538972a37c6.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1158
// module chunks = 0